import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

//------------------------------------------------------------------------------

function UnderlinedInput(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { placeholder, value, onChange } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  return (
    <input
      className={props.className}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
    />
  )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

UnderlinedInput.propTypes = {
  className: PropTypes.string.isRequired,
  fontSize: PropTypes.number,
  fontWeight: PropTypes.number,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.any,
}

UnderlinedInput.defaultProps = {
  fontSize: 14,
  fontWeight: 400,
}

// ----------------------------------------------------------------------------

const StyledUnderlinedInput = styled(UnderlinedInput)`
  & {
    padding: 5px 0;
    width: 100%;

    border: none;
    border-bottom: 1px solid ${(props) => props.theme.colors.borderColor};

    font-size: ${(props) =>
      props.fontSize || UnderlinedInput.defaultProps.fontSize}px;
    font-weight: ${(props) =>
      props.fontWeight || UnderlinedInput.defaultProps.fontWeight};

    line-height: ${(props) =>
      props.fontSize || UnderlinedInput.defaultProps.fontSize}px;

    color: ${(props) => props.theme.colors.textPrimaryColor};

    outline: none;
    appearance: none;

    ::placeholder {
      font-size: ${(props) =>
        props.fontSize || UnderlinedInput.defaultProps.fontSize}px;
      font-weight: 400;
      color: ${(props) => props.theme.colors.placeholderColor};
    }
  }
`
// ----------------------------------------------------------------------------

export default StyledUnderlinedInput
